import React, { Suspense, useLayoutEffect } from "react";
import { Routes, Route } from "react-router-dom";

import { routes } from "./configs/routes";

const Pages = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <Suspense fallback={<div />}>
      <Routes>
        {routes.map((route) => {
          // Remove leading slash to make routes relative to the parent /:lang route
          const path =
            route.path === "/"
              ? ""
              : route.path.startsWith("/")
                ? route.path.substring(1)
                : route.path;

          return (
            <Route
              path={path}
              element={route.element}
              key={route.path}
            />
          );
        })}
      </Routes>
    </Suspense>
  );
};

export default Pages;
